<template> 
  <button
   v-tooltip="tooltip"
    class="action-item"
    :class="{
      'action-item--alert': isAlert,
      'action-item--warn': isWarn
    }"
    :disabled="disabled"
    @click="handleClick(eventKey)"
  >
    <SVGIcon
      v-if="icon"
      :iconName="icon"
      :width="'24px'"
      :height="'24px'"
      style="margin-right: 8px; display: inline-block;"
    />
   
    {{ label }} 
  </button>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import SVGIcon from '@/components/SVGIcon.vue';

defineProps({
  /**
   * Icon name for the action item
   */
  icon: {
    type: String,
    default: null,
  },
  /**
   * Label text for the action item
   */
  label: {
    type: String,
    required: true,
  },
  /**
   * Event key to emit when clicked
   */
  eventKey: {
    type: String,
    required: true,
  },
  /**
   * Make the item red (alert style)
   */
  isAlert: {
    type: Boolean,
    default: false,
  },
  /**
   * Make the item gold/warning style
   */
  isWarn: {
    type: Boolean,
    default: false,
  },
  /**
   * Disable the action item
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * Tooltip text to display on hover
   */
  tooltip: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['click']);

const handleClick = (eventKey) => {
  emit('click', eventKey);
};
</script>

<style lang="scss" scoped>

.action-item {
  padding: 8px 18px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  border: none;
  background: none;
  width: calc(100% - 12px);
  text-align: left;
  display: flex;
  align-items: center;
  margin: 0 6px;
  border-radius: 4px;

  @include themify() {
    color: themed('body-text-color');
  }

  &:hover{
    background-color: #cdd4ec;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &--alert {
    color: #ef4444 !important;
  }

  &--warn {
    color: #926414 !important;
  }
}

</style>
